export default [{
  name: 'JSON',
  fields: [{
    label: 'JSON',
    type: 'json',
    required: true
  }]
}, {
  name: 'Rich text editor',
  path: 'renderers/content', // TODO not a real path
  fields: [{
    label: 'Content',
    key: 'content',
    type: 'wysiwyg',
    required: false
  }]
}, {
  name: 'VideoBlock',
  path: 'VideoBlock',
  fields: [{
    label: 'Viedo URL',
    key: 'video_url',
    type: 'string',
    required: false
  }, {
    label: 'HTML classes',
    key: 'html_classes',
    type: 'string',
    required: false
  }, {
    label: 'Mobile title',
    key: 'title_mobile',
    type: 'string',
    required: false
  }]
}, {
  name: 'PartnersBlock',
  path: 'PartnersBlock',
  fields: [{
    label: 'Partners',
    key: 'config',
    type: 'json',
    required: true
  }]
}, {
  name: 'MobileActionBar',
  path: 'MobileActionBar',
  fields: [{
    label: 'Loan Route',
    key: 'loan.route',
    type: 'string',
    required: true
  }, {
    label: 'Loan Title',
    key: 'loan.title',
    type: 'string',
    required: true
  }, {
    label: 'Faq Route',
    key: 'faq.route',
    type: 'string',
    required: true
  }, {
    label: 'Faq Title',
    key: 'faq.title',
    type: 'string',
    required: true
  }]
}]
